import {Component, Prop, Emit, Watch, Vue} from 'vue-property-decorator';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import UnitPrices from '@/components/UnitPrices/UnitPrices.vue';
import { Machine, File, UnitPrice } from '@/types';
import store from '@/assets/common/store/store';

@Component({
    components: {
        Thumbnail,
        UnitPrices
    }
})
export default class MachineDetail extends Vue {
    private unitPrice: any | null = null;
    private unEditedMachine!: Machine;
    private machineName = "";
    private machineMemo = "";
    private baseUrl = "/machines"
    private machinesUnitPrices: UnitPrice[] = [];
    private selectedMachine: Machine = {
        id: '',
        name: '',
        memo: '',
        image_id: '',
        is_hidden: false,
        unit: null
    };
    private selectedMachineImage: File = {
        id:  '',
        url: '',
        meta: {
            name: '',
            mime_type: '',
            size: 0
        },
        file : null
    };

    @Prop()
    private selectedMachineId!: string;

    @Prop()
    private isAdmin!: boolean;

    @Prop()
    private title!: string;

    private isDeleteImage = false

    private get headerTitle() {
        if(this.selectedMachineId === 'create') {
            return '機械新規作成';
        } else {
            return '機械情報';
        }
    }

    @Watch('isAdmin')
    @Watch("selectedMachineId", { immediate: true })
    private async changedMachineId() {
        this.unitPrice = null;
        this.isDeleteImage = false
        if(this.selectedMachineId && this.selectedMachineId != 'create') {
            if(this.isAdmin) {
                await this.$apiClient.doRequest('get', `/admin${this.baseUrl}/${this.selectedMachineId}`).then((res) => {
                    this.selectedMachine = res;
                    this.machineName = res.name;
                    this.machineMemo = res.memo;
                    this.machinesUnitPrices = res.unit;
                    this.unitPrice = UnitPrices;
                });
            } else {
                await this.$apiClient.doRequest('get', `${this.baseUrl}/${this.selectedMachineId}`).then((res) => {
                    this.selectedMachine = res;
                    this.machineName = res.name;
                    this.machineMemo = res.memo;
                    if(this.machinesUnitPrices) {
                        this.machinesUnitPrices.splice(0, this.machinesUnitPrices.length)
                    }
                    this.unitPrice = UnitPrices;
                });
            }

            this.unEditedMachine = this.selectedMachine;

            // 画像情報の取得
            if(this.selectedMachine.image_id) {
                this.$apiClient.doRequest('get', `${this.baseUrl}/${this.selectedMachineId}/image`).then((res) => {
                    this.selectedMachineImage = res;
                });
            }
        } else {
            this.selectedMachine = {
                 id: this.selectedMachineId,
                 name: '',
                 memo: '',
                 image_id: '',
                 is_hidden: false,
                 unit: null
             };
            this.machineName = '';
            this.machineMemo = '';
            if(this.machinesUnitPrices) {
                this.machinesUnitPrices.splice(0, this.machinesUnitPrices.length);
            }
            this.unitPrice = UnitPrices;

            const refs: any = this.$refs
            if(refs.unitPrices){
                refs.unitPrices.cleanUnitPrices()
            }
        }
    }

    private deleteImage() {
        this.selectedMachineImage.url = ''
        this.selectedMachineImage.file = null
        this.selectedMachine.image_id = ''
        this.isDeleteImage = true
        this.inputChanged();
    }

    private onFileChange(e: any) {
        this.inputChanged();
        const files = e.target.files || e.dataTransfer.files;
        if(this.$apiClient.isSizeOver(files)) {
            return;
        }

        if(this.$apiClient.isImageFile(files[0].name)){
            this.$apiClient.getBase64(files[0]).then((image: any) => {
                this.selectedMachineImage = {
                    id:  'create',
                    url: image.base64 as string,
                    meta: {
                        name: '',
                        mime_type: '',
                        size: 0
                    },
                    file : files[0]
                };
                this.selectedMachine.image_id = this.selectedMachineImage.id
            }).catch(() => {
                window.alert('画像ファイルが読み込めませんでした')
            });
        }else {
            window.alert('画像ファイルを選択してください')
        }
    }

    private submit() {
        let errmsg: string[] = []
        // 名前の入力
        if(!this.machineName.trim()) {
            errmsg.push("機械名を入力してください")
        }
        // 名前の長さ
        if(this.machineName.length > 100) {
            errmsg.push(`機械名は100文字以内で入力してください（現在は${this.machineName.length}文字）`)
        }
        const refs: any = this.$refs
        // メモ
        if(this.machineMemo && this.machineMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.machineMemo.length}文字）`)
        }

        let unitPrices = []
        if(refs.unitPrices) {
            unitPrices = refs.unitPrices.getUnitPrices()
            // 戻ってきた型がstring[]だったらエラーメッセージの配列
            if(unitPrices.length > 0 && typeof unitPrices[0] === 'string') {
                errmsg = errmsg.concat(unitPrices)
            }
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        const newMachine: Machine = {
            id: this.selectedMachineId,
            name: this.machineName,
            memo: this.machineMemo,
            image_id: this.selectedMachine.image_id,
            is_hidden: this.selectedMachine.is_hidden,
            unit: unitPrices,
        }

        const apiBaseUrl = this.isAdmin ? `/admin${this.baseUrl}` : this.baseUrl

        if(this.selectedMachineId === 'create') {
            const postRequest = this.$apiClient.doRequest('post', apiBaseUrl, newMachine)
            postRequest.then((res)=>{
                this.machinesUnitPrices = res.unit;
                return res.id
            }).then((id: string)=>{
                // ファイルアップロード
                if(this.selectedMachineImage.file){
                    this.uploadFile(id)
                }else{
                    this.submitEnd(id);
                }
            }).catch(error => {
                this.$toasted.error('変更に失敗しました。')
            })
        } else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                return false;
            }
            this.$apiClient.doRequest('put', `${apiBaseUrl}/${this.selectedMachineId}`, newMachine).then((res) => {
                this.machinesUnitPrices = res.unit;
                return res.id
            }).then((id: string)=>{
                // ファイルの削除
                if(this.isDeleteImage){
                    this.$apiClient.doRequest('delete', `${this.baseUrl}/${id}/image`).then((res) => {
                        this.selectedMachine.image_id = ''
                        this.isDeleteImage = false
                    });
                }

                // ファイルアップロード                
                if(this.selectedMachineImage.file){
                    this.uploadFile(id)
                }else{
                    this.submitEnd(id);
                }
            })
            .catch(error => {
                this.$toasted.error('変更に失敗しました。')
            })
            this.unEditedMachine = newMachine;
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);

    }

    private uploadFile(machineId: string) {
        this.$apiClient.fileUpload(`${this.baseUrl}/${machineId}/image`, this.selectedMachineImage.file).then((res)=>{
            this.selectedMachineImage.file = null
            this.selectedMachine.image_id = res.id;
            this.submitEnd(machineId);
        })
        .catch(error => {
            this.$toasted.error('変更に失敗しました。')
        })
    }

    private switchDisplay(isHidden: boolean) {

          if (!window.confirm(`${this.machineName}を${ !isHidden? '表示状態に戻します' : '非表示にします' }。よろしいですか？`)){
              return
          }

          this.selectedMachine.is_hidden = isHidden;

          this.$apiClient.doRequest('put', `${this.baseUrl}/${this.selectedMachineId}`, this.selectedMachine).then((res) => {
                if(isHidden) {
                    this.$router.push('/master/machines', () => {return});
                } else {
                    this.$router.push(`/master/machines/${this.selectedMachineId}`, () => {return});
                }
                this.submitEnd(this.selectedMachineId);
          }).catch(error => {
              this.$toasted.error('変更に失敗しました。')
          })
    }

    private cancelEdit() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        this.changedMachineId();
    }

    @Emit('submitEnd')
    private submitEnd(machineId: string) {
        this.$toasted.success('変更を保存しました。')
        return machineId;
    }

    @Emit('inputChanged')
    private inputChanged(){
       if(store.getters.isInputChanged==false){
		this.$store.dispatch('doUpdateIsInputChanged', true);
		}
    }
}
